import { render, staticRenderFns } from "./user-account.vue?vue&type=template&id=6c6b47db"
import script from "./user-account.vue?vue&type=script&lang=js"
export * from "./user-account.vue?vue&type=script&lang=js"
import style0 from "../../../core/input/input.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "../../../core/form/grid.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports